import { isRoomCode, normalizeRoomCode } from '@pixelworld/shared';

export function parseRoomCode(input: string): string | null {
  const code = normalizeRoomCode(input);
  return isRoomCode(code) ? code : null;
}
